import { Icon, Tooltip } from '@mairistem/composants';
import { Feature, Menu } from '@mairistem/module';

import { showTooltips } from '@/utils';
import { ModeReglementContextProvider } from '../Context';
import { Accueil } from './v2';

const MenuAccueil = () => (
  <Menu
    code="__HOME__"
    name="Accueil"
    icon={
      showTooltips ? (
        <Tooltip trigger={<Icon name="home" />} message="Accueil" position="right center" />
      ) : (
        <Icon name="home" />
      )
    }
    path="/"
    exact
  >
    <Feature name="Accueil">
      <Feature.Content>
        <ModeReglementContextProvider autoload="régie">
          <Accueil />
        </ModeReglementContextProvider>
      </Feature.Content>
    </Feature>
  </Menu>
);

export default MenuAccueil;
